<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Sản phẩm</strong>
          </div>
          <b-form @submit.prevent="search">
            <b-row>
              <b-col>
                <b-form-group
                  label="Danh mục:"
                  label-for="input-name"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <!--<b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>-->
                  <treeselect
                    :multiple="true"
                    class="col-6 no-padding"
                    id="categoryIds"
                    v-if="categories.length > 0"
                    v-model="searchForm.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên sản phẩm:"
                  label-for="input-name"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    class="col-6"
                    id="input-name"
                    v-model="searchForm.str"
                    placeholder="Nhập tên hoặc mã ..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="4">
                  <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <b-grid
            :searchForm="searchForm"
            :gridOptions="gridOptions"
            selectable
            dataUrl="master-data/products"
            gridName="Danh sách sản phẩm"
            ref="productTable"
          >
            <template v-slot:actions>
              <router-link
                v-if="authorize(['ManageProduct'])"
                to="/master-data/products/create"
                tag="button"
                class="btn btn-primary"
                size="md"
              >
                Thêm mới
              </router-link>
              <b-button
                size="md"
                @click.stop="deletes"
                variant="danger"
                :disabled="isDisabledDelete"
              >
                Xóa
              </b-button>
            </template>
            <!--<template v-slot:cell(urlImage)="row">
                            <b-button size="sm" v-b-modal.modalPopover @click.stop="showImage(row.item, row.index, $event.target)" title="Xem ảnh">
                                <i class="fa fa-eye" aria-hidden="true"></i>
                            </b-button>
                        </template>-->
            <template v-slot:cell(status)="row">
              <b-form-checkbox
                v-model="row.value"
                @change="updateStatus(row.item, $event)"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(isPrioritizeShow)="row">
              <b-form-checkbox
                v-model="row.value"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <b-button
                  v-if="authorize(['ViewProduct'])"
                  size="sm"
                  :to="{ path: `./detail/${row.item.id}` }"
                  title="xem"
                  variant="info"
                >
                  Xem
                </b-button>
                <template>
                  <b-button
                    v-if="authorize(['ManageProduct'])"
                    size="sm"
                    :to="{ path: `./manage-images/${row.item.id}`, query: { page: 3 } }"
                    title="sửa"
                    variant="primary"
                  >
                    Ql hình ảnh
                    <span class="badge badge-light">{{
                      row.item.countImage
                    }}</span>
                  </b-button>

                  <b-button
                    v-if="authorize(['ManageProduct'])"
                    size="sm"
                    :to="{ path: `./edit/${row.item.id}` }"
                    title="sửa"
                    variant="primary"
                  >
                    Sửa
                  </b-button>
                  <b-button
                    v-if="authorize(['ManageProduct'])"
                    size="sm"
                    @click.stop="remove(row.item, row.index, $event.target)"
                    class="mr-1"
                    title="xóa"
                    variant="danger"
                  >
                    Xoá
                  </b-button>
                </template>
              </b-button-group>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>

    <!--<b-modal id="modalPopover" size="xl" title="Modal with Popover" lazy="true"
                 static
                 no-close-on-backdrop>
            <b-grid :gridOptions="gridImageOptions"
                    selectable
                    :items="items"
                    gridName="Danh sách hình ảnh sản phẩm"
                    ref="listImage">
                <template v-slot:actions>
                    <router-link v-if="authorize(['ManageProduct'])" to="/master-data/products/create" tag="button" class="btn btn-primary" size="md">
                        Thêm mới
                    </router-link>
                    <b-button size="md" @click.stop="deletes" variant="danger" :disabled="isDisabledDelete">
                        Xóa
                    </b-button>
                </template>


                <template v-slot:cell(_actions)="row">
                    <b-button-group>
                        <template>
                            <b-button v-if="authorize(['ManageProduct'])" size="sm" :to="{ path: `./edit/${row.item.id}` }" title="sửa" variant="primary">
                                Sửa
                            </b-button>
                            <b-button v-if="authorize(['ManageProduct'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                Xoá
                            </b-button>
                        </template>
                    </b-button-group>
                </template>
            </b-grid>
            <b-img center :src="urlImage2" alt="image" style="width: 100%;"></b-img>
            <template #modal-footer="{ ok, cancel }">-->
    <!-- Emulate built in modal footer ok and cancel button actions -->
    <!--<b-button size="sm" variant="primary" @click="ok()">
                    Lưu
                </b-button>
                <b-button size="sm" variant="secondary" @click="cancel()">
                    Hủy
                </b-button>
            </template>
        </b-modal>-->
  </div>
</template>
<script>
import { authorizationMixin } from "@/shared/mixins";
import { mapState } from "vuex";
export default {
  name: "ListDiscountCode",
  mixins: [authorizationMixin],
  data() {
    return {
      searchForm: {
        str: null,
        categoryIds: [],
        categoryId: null,
      },
      isDisabledDelete: true,
      gridOptions: {
        fields: [
          {
            key: "categoryName",
            label: "Danh mục",
            sortable: false,
          },
          {
            key: "code",
            label: "Mã sản phẩm",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "title",
            label: "Tiêu đề",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "slug",
            label: "Tên không dấu",
            sortable: true,
            sortDirection: "asc",
          },
          //{ key: 'urlImage', label: 'Đường dẫn hình ảnh', sortable: true, sortDirection: 'asc' },
          { key: "status", label: "Trạng thái", sortable: false },
          { key: "isPrioritizeShow", label: "Ưu tiên hiển thị", sortable: false },
        ],
        sortBy: "id",
      },
      gridImageOptions: {
        fields: [
          {
            key: "preview",
            label: "Xem trước",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "urlImage",
            label: "Đường dẫn",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "sizeImage",
            label: "Kích thước",
            sortable: true,
            sortDirection: "asc",
          },
        ],
        sortBy: null,
      },
      items: [
        { preview: true, urlImage: 40, sizeImage: "Dickerson" },
        { preview: true, urlImage: 89, sizeImage: "Shaw" },
        { preview: true, urlImage: 21, sizeImage: "Carney" },
        { preview: true, urlImage: 38, sizeImage: "Wilson" },
      ],
    };
  },
  computed: {
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
    page() {
      if(this.$refs.productTable){
        return this.$refs.productTable.options.page;
      }
    }
  },
  watch: {
    searchForm: {
      handler: function (val, oldVal) {
        // Return the object that changed
        this.stringToArray();
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.$watch(
      () => {
        return this.$refs.productTable.selectedRows;
      },
      (val) => {
        this.isDisabledDelete = val.length == 0;
      }
    );
  },
  methods: {
    search() {
      this.$refs.productTable.refresh();
    },
    remove(item) {
      var vm = this;

      if (confirm("Bạn có chắc chắn muốn xóa sản phẩm này?")) {
        this.$services.delete(`master-data/products/${item.id}`).done(() => {
          vm.$toastr.s("Xóa sản phẩm thành công");
          vm.search();
        });
      }
    },
    deletes() {
      var vm = this;
      var selectedRows = this.$refs.productTable.selectedRows;
      if (selectedRows.length > 0) {
        if (confirm("Bạn có chắc chắn muốn xóa các sản phẩm này?")) {
          var data = selectedRows.map((x) => x.id).join(",");
          this.$services.delete(`master-data/products?ids=${data}`).done(() => {
            vm.$toastr.s("Xóa sản phẩm thành công");
            vm.search();
          });
        }
      } else {
        vm.$toastr.e("Vui lòng chọn sản phẩm cần xóa");
      }
    },
    stringToArray(){
        this.searchForm.categoryId = this.searchForm.categoryIds.join(',');
    }
  },
};
</script>
<style scoped>
</style>
